import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService, GoogleAnalyticsService, LogoutInactivityService } from 'aih-launchpad-core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private languageService: LanguageService,
    private analyticsService: GoogleAnalyticsService,
    private logoutInactivityService: LogoutInactivityService
  ) {
    this.languageService.language$
      .pipe(takeUntilDestroyed())
      .subscribe(lang => {
        console.log('Language changed to: ', lang);
        this.translate.use(lang);
      });
  }

  ngOnInit(): void {
    this.analyticsService.load();
    this.logoutInactivityService.initiateAutomaticLogout();
  }
}
